import type { Customer } from '../../types';
import {
  formatReservationListPhoneSubtitle,
  getCustomerPhoneForDisplay,
  getTelHrefForPhone,
} from '../../lib/customerClassification';

type Props = {
  customer: Pick<Customer, 'name' | 'phone'> | null | undefined;
};

/**
 * Second line under guest name in list view: dialable numbers are `tel:` links
 * so tapping calls without opening the row (stopPropagation).
 */
export function ReservationListPhoneCell({ customer }: Props) {
  const display = getCustomerPhoneForDisplay(customer);
  const fallbackText = formatReservationListPhoneSubtitle(customer);
  const href = display ? getTelHrefForPhone(display) : null;

  if (!href) {
    return <span className="text-sm text-muted-foreground">{fallbackText}</span>;
  }

  return (
    <a
      href={href}
      onClick={(e) => e.stopPropagation()}
      onPointerDown={(e) => e.stopPropagation()}
      className="text-sm font-medium text-primary underline-offset-2 hover:underline decoration-primary/70 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background rounded-sm"
      aria-label={`Κλήση στο ${display}`}
    >
      {display}
    </a>
  );
}
